import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { forEach, groupBy } from 'lodash';
import cx from 'classnames';

import Checkbox from 'components/Checkbox';
import { DisabledTooltipLayer } from './SelectFromList';
import EventTracking from 'lib/EventTracking';
import GroupRecipientAvatar from 'chat_v2/components/GroupRecipientAvatar';
import MediaObject from 'components/MediaObject';
import TargetFilterMenu from 'chat_v2/components/TargetFilterMenu';
import Text from 'components/Text';
import { ComposerContext } from './ComposerContext';
import { UIEventContext } from './ComposerContext';
import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';
import { ComposerDispatchContext, ComposerStateContext } from 'chat_v2/ComposerContext';

type Props = {
  entity: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity,
  recipientIsSelected: boolean,
  disabledCopy?: React.ReactNode;
};

export default class GroupRecipientItem extends React.Component<Props> {
  renderGroupRecipient = () => {
    const { entity, recipientIsSelected } = this.props;
    const { content, recipient } = entity;

    const filterArray = recipient.filters?.map(filter => (
      <ComposerStateContext.Consumer>
        {composerState =>
          <TargetFilterMenu
            key={filter.key}
            filter={filter}
            entity={entity}
            dataTestSelector={`split-composer-group-filter-${recipient.uuid}`}
            composerState={composerState}
          />
        }
      </ComposerStateContext.Consumer>
    ));

    return (
      <MediaObject gutter="small" center>
        <GroupRecipientAvatar entity={entity} size="small" />
        <div>
          <Text size="small" element="div" truncate>
            {content.title}
          </Text>
          {filterArray}
        </div>
      </MediaObject>
    );
  };

  render() {
    const { entity, disabledCopy, recipientIsSelected } = this.props;

    const component = (
      <ComposerDispatchContext.Consumer>
        {composerDispatch => (
          <ComposerContext.Consumer>
            {composerContext => { 
              const selectionHandler = (event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent) => {
                event.preventDefault();
                
                if (recipientIsSelected) {
                  composerDispatch({ type: 'removeRecipient', uuid: entity.recipient.uuid });
                } else {
                  composerDispatch({ type: 'addRecipient', entity });
                }

                EventTracking.trackKey(`announcements.share_to.group.${recipientIsSelected ? 'un' : ''}select.click`, composerContext.getUIEventContext());
              };

              return (
                <li
                  className={cx('RecipientItem', {
                    'RecipientItem--disabled': !!disabledCopy,
                  })}
                  key={entity.recipient.uuid}
                  onClick={selectionHandler}
                  data-test-selector={`split-composer-group-${entity.recipient.uuid}`}>
                  <MediaObject figure="right" center>
                    {this.renderGroupRecipient()}
                    <Checkbox onChange={selectionHandler} checked={recipientIsSelected} />
                  </MediaObject>
                </li>
              )
            }}
          </ComposerContext.Consumer>
        )}
      </ComposerDispatchContext.Consumer>
    );

    if (disabledCopy) {
      return <DisabledTooltipLayer text={disabledCopy}>{component}</DisabledTooltipLayer>;
    }

    return component;
  }
}
